import SalesOffice from './SalesOffice'
import Employee from './Employee'
export class SaveSalesOfficeRequest {
    SalesOffice: SalesOffice;
    SavedByEmployee: Employee;
}

export default SaveSalesOfficeRequest;